import type { WebSocketConfig } from './notification.types';

/**
 * A default definition of websocket configuration values
 */
export const DEFAULT_WEBSOCKET_CONFIG: WebSocketConfig = {
  /** Maximum number of reconnection attempts */
  maxReconnectAttempts: 5,
  /** Initial reconnection delay in milliseconds */
  reconnectDelayMs: 1000,
  /** Maximum reconnection delay in milliseconds (for exponential backoff) */
  maxReconnectDelayMs: 30000,
  /** Timeout for connection attempts in milliseconds */
  connectionTimeoutMs: 10000,
  /** Heartbeat interval in milliseconds */
  heartbeatIntervalMs: 30000,
};
